import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";
import { VOMarker } from "../../model/Structure.js";
import { Language } from "../../model/Language.js";

export class ControlMarkerlist extends BaseControl {

    private _list: HTMLDivElement;
    private _active: boolean = false;
    private _items: ControlMarkerlistItem[] = [];

    constructor(pano: Pano) {
        super(pano, ControlPosition.RIGHT);

        this.element.classList.add("control-button", "navi");
        this.element.innerHTML = `
        <div class="control-button-icon icon-865"></div>
        `;
        this._list = document.createElement("div");
        this._list.classList.add("marker-outofview");
        this.pano.wrapper.appendChild(this._list);

        pano.onChangeVideo.add((video) => {
            for (var item of this._items)
                item.dispose();

            this._items = [];
            this._list.innerHTML = "";
            if (!video || !video.markers || video.markers.length === 0) {
                this.visible = false;
                return;
            }

            for (var marker of video.markers) {
                this.addItem(marker);
            }
            this.visible = true;
        });

        this.element.addEventListener("click", (e) => {
            this.active = !this.active;
        });

        this.onVisibilityChanged.add((visible) => {
            this._list.classList.toggle("hidden", !visible);
        });

        this.active = true;
    }

    protected get active(): boolean {
        return this._active;
    }

    protected set active(active: boolean) {
        if (this._active === active)
            return;
        this._active = active;
        this.element.classList.toggle("active", active);
        this._list.classList.toggle("active", active);
    }

    private addItem(marker: VOMarker): void {
        var item = new ControlMarkerlistItem(marker, this.pano);
        this._items.push(item);
        this._list.appendChild(item.element);
    }
}

class ControlMarkerlistItem {
    public element: HTMLDivElement;
    private _marker: VOMarker;
    private _onClick: (e: MouseEvent) => void;

    constructor(marker: VOMarker, public pano: Pano) {
        this._marker = marker;

        this.element = document.createElement("div");
        this.element.className = "marker-delegate";

        var label = document.createElement("div");
        label.classList.add("label");
        Language.apply(label, marker.marker_label_de, marker.marker_label);
        this.element.appendChild(label);

        //Arrow right "icon-124".
        //Magnify "icon-479"
        var trigger = document.createElement("div");
        trigger.classList.add("trigger");
        trigger.classList.add("icon-" + marker.marker_icon);
        this.element.appendChild(trigger);

        this._marker.delegates.push(this);

        this._onClick = (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.trigger();
        };

        this.element.addEventListener("click", this._onClick);
    }

    public trigger(): void {
        this.pano.view.lookAtMarker(this._marker);
    }

    public get visible(): boolean {
        return !this.element.classList.contains("hidden");
    }

    public set visible(visible: boolean) {
        this.element.classList.toggle("hidden", !visible);
    }

    public dispose(): void {
        this.element.removeEventListener("click", this._onClick);
        this._marker.delegates.splice(this._marker.delegates.indexOf(this), 1);
        this.element.remove();
    }
}